import React, { FunctionComponent, useId } from 'react';
import { cn } from '@/utils/cn';
import { TOUCH_HIT_AREA } from '@/utils/touchTarget';

type BurgerProps = {
  openMobileMenu: () => void;
  isOpen: boolean;
  closeMobileMenu: () => void;
  onIntent?: () => void;
};

export const Burger: FunctionComponent<BurgerProps> = ({
  openMobileMenu,
  isOpen,
  closeMobileMenu,
  onIntent
}) => {
  const id = useId().replace(/:/g, '');

  return (
    <>
      <style>{`
        .burger-${id} .burger-line:first-child {
          transform: ${isOpen ? 'translateY(5px) rotate(45deg)' : 'translateY(0) rotate(0)'};
        }
        .burger-${id} .burger-line:nth-child(2) {
          opacity: ${isOpen ? '0' : '1'};
          transform: ${isOpen ? 'scaleX(0)' : 'scaleX(1)'};
        }
        .burger-${id} .burger-line:nth-child(3) {
          transform: ${isOpen ? 'translateY(-5px) rotate(-45deg)' : 'translateY(0) rotate(0)'};
        }
      `}</style>
      <button
        type="button"
        aria-label={isOpen ? 'Cerrar menú' : 'Abrir menú'}
        onClick={isOpen ? closeMobileMenu : openMobileMenu}
        onPointerEnter={onIntent}
        onFocus={onIntent}
        onTouchStart={onIntent}
        className={cn(
          `burger-${id}`,
          // 40 px a la vista, 44 px al toque. Sin caja: el ícono suelto, como la campana.
          // Tres rayas de 13px a 5px de paso (la `fa-bars` de 15px de la maqueta).
          'relative flex h-10 w-10 flex-col items-center justify-center gap-[3px] rounded-lg p-0',
          TOUCH_HIT_AREA,
          'transition-[background-color,color] duration-200 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)]',
          'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-frost-brand/30 focus-visible:ring-offset-2',
          isOpen ? 'text-frost-brand' : 'text-frost-ink hover:bg-[rgba(var(--f-ink-rgb),0.05)]'
        )}
      >
        <span className="burger-line relative h-0.5 w-[13px] origin-center rounded-full bg-current transition-[transform,opacity,background-color] duration-300 ease-in-out" />
        <span className="burger-line relative h-0.5 w-[13px] origin-center rounded-full bg-current transition-[transform,opacity,background-color] duration-300 ease-in-out" />
        <span className="burger-line relative h-0.5 w-[13px] origin-center rounded-full bg-current transition-[transform,opacity,background-color] duration-300 ease-in-out" />
      </button>
    </>
  );
};
